import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    'https://public.readdy.ai/ai/img_res/251973e9afbaa6b5a54cac6dc567bf09.jpg',
    'https://readdy.ai/api/search-image?query=Two%20professional%20Black%20male%20movers%20in%20uniform%20handling%20desks%20computers%20and%20office%20equipment%20in%20modern%20office%20space%20during%20commercial%20relocation%2C%20organized%20efficient%20moving%20process%20showing%20business%20moving%20expertise%2C%20clean%20simple%20background%2C%20commercial%20photography%20quality%20capturing%20diverse%20team%20collaboration%2C%20professional%20office%20moving%20service&width=1920&height=1080&seq=hero-office-move-001&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Two%20professional%20Black%20male%20movers%20in%20uniform%20carefully%20loading%20a%20single%20large%20sofa%20furniture%20piece%20into%20white%20van%20with%20care%20and%20precision%2C%20simple%20clean%20background%20showing%20careful%20handling%20and%20attention%20to%20detail%2C%20bright%20daylight%2C%20high%20quality%20service%20photography%2C%20diverse%20team%20demonstrating%20single%20item%20collection%20expertise&width=1920&height=1080&seq=hero-single-item-001&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Two%20professional%20workers%20in%20uniform%20clearing%20furniture%20and%20items%20from%20empty%20apartment%20interior%20during%20end%20of%20tenancy%20clearance%2C%20one%20white%20male%20and%20one%20Black%20male%20working%20together%20as%20diverse%20team%2C%20efficient%20property%20clearance%20service%2C%20clean%20simple%20background%20showing%20complete%20clearance%20process%2C%20bright%20natural%20lighting%2C%20professional%20team%20collaboration%20on%20tenancy%20clearance&width=1920&height=1080&seq=hero-tenancy-clearance-001&orientation=landscape',
    'https://static.readdy.ai/image/ab43357bf771d1fcf31d3399e10c2db6/e19d59252650f638daa873fadfc8b155.jpeg'
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Slideshow Background */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000"
          style={{
            backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.97) 0%, rgba(255, 255, 255, 0.97) 50%, rgba(255, 255, 255, 0.75) 70%, rgba(255, 255, 255, 0.4) 100%), url('${slide}')`,
            opacity: currentSlide === index ? 1 : 0,
            zIndex: currentSlide === index ? 1 : 0
          }}
        />
      ))}

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              currentSlide === index ? 'bg-white w-8' : 'bg-white/50'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Content */}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
        <div className="flex items-center justify-between gap-12">
          <div className="max-w-2xl relative">
            <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full mb-6">
              <i className="ri-shield-check-line"></i>
              <span className="text-sm font-medium whitespace-nowrap">Fully Insured & Licensed</span>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Man & Van Services Ltd
            </h1>
            
            <p className="text-2xl text-gray-600 mb-8 leading-relaxed">
              Reliable house removals, office moves, and single item collections. Fast, affordable, and stress-free moving solutions tailored to your needs. We cover all over the U.K. and Europe
            </p>

            <div className="flex flex-wrap gap-4 mb-12">
              <button 
                onClick={scrollToContact}
                className="bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-all font-semibold text-lg shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                Get Free Quote
              </button>
              <a 
                href="tel:+441234567890"
                className="bg-white text-blue-600 px-8 py-4 rounded-lg hover:bg-gray-50 transition-all font-semibold text-lg border-2 border-blue-600 flex items-center gap-2 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                Call Now
              </a>
            </div>

            <div className="grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-1">100+</div>
                <div className="text-sm text-gray-600">Happy Customers</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-1">5★</div>
                <div className="text-sm text-gray-600">Average Rating</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-1">24/7</div>
                <div className="text-sm text-gray-600">Available</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
